/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

// Core Libraries
import { Component, OnInit, OnDestroy, Output, Input, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyPipe } from '@angular/common';

// Constants
import { SYMBOL_CONSTANTS } from '@support/shared/constants/device.constants';

// Interfaces
import { EpinConflictResponse } from '@experience/shop/product-details/interfaces/product-details.interface';
import { ObjectInterface } from '@support/api/common/api-response.interface';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { ConfigData } from '@experience/repdash/interfaces/aem-content.interface';

@Component({
  selector: 'tmo-epin-conflict-modal',
  templateUrl: './epin-conflict-modal.component.html',
  styleUrls: [],
})
export class EPinConflictModalComponent implements OnInit, OnDestroy {
  /**
   * Constants for autopay page
   */
  public symbolContants: ObjectInterface;
  /**
   * Stores show/hide boolean value for modal
   */
  public displayModal: Boolean;
  /**
   * Stores current Selection Price
   */
  public currentSelectionPrice: string;
  /**
   * Stores the content coming from AEM call
   */
  @Input() public staticContent: ConfigData;
  /**
   * Stores whether BYOS
   */
  @Input() public isByos: boolean;
  /**
   * Stores the new Selection Name
   */
  @Input() public newSelectionName: string;
  /**
   * currentSelectionAmount to store selected amount
   */
  @Input() public currentSelectionAmount: number;
  /**
   * Stores whether current selection is epin
   */
  @Input() public isEpin: boolean;

  /**
   * Event Emitter to trigger events on closing the modal
   */
  @Input() public epinConflictData: EpinConflictResponse;
  /**
   * To create the modal
   */
  public modal: DynamicModal;
  /**
   * Event Emitter to trigger events on closing the modal
   * @type {EventEmitter<boolean>}
   * @memberof EPinConflictModalComponent
   */
  @Output() public addNewSelectionInCart: EventEmitter<boolean>;
  /**
   * Event Emitter to trigger events on closing the modal
   * @type {EventEmitter<boolean>}
   * @memberof EPinConflictModalComponent
   */
  @Output() public closeModal: EventEmitter<boolean>;

  constructor(
    private router: Router,
    private currencyPipe: CurrencyPipe,
    public activatedRoute: ActivatedRoute
  ) {
    this.addNewSelectionInCart = new EventEmitter<boolean>();
    this.closeModal = new EventEmitter<boolean>();
    this.modal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'epin-conflict-modal',
    };
  }

  /**
   * loads the initial state of product offerings component
   * @returns void
   */
  public ngOnInit(): void {
    this.symbolContants = SYMBOL_CONSTANTS;
    if (this.epinConflictData) {
      this.displayModal = true;
    }
    this.currentSelectionPrice = this.currencyPipe.transform(
      this.currentSelectionAmount || 0,
      'USD',
      'symbol-narrow',
      '1.2-2'
    );
  }

  /**
   * Method used to destroy data, subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {}

  /**
   * Method to Close Order Epin Conflict Modal
   * @param {EventEmitter<Object>} [event]
   * @returns void
   */
  public closeEPinConflictModal(event?: EventEmitter<Object>): void {
    this.displayModal = false;
    this.closeModal.emit(true);
  }

  /**
   * navigate to cart if user select to go with current cart selection
   * @returns void
   */
  public goToCurrentCartSelection(): void {
    this.router.navigate(['/cart']);
  }

  /**
   * adds accessory to cart or updates the quantity if the accessory already exists
   * @returns void
   */
  public addNewSelectionToCart(): void {
    this.displayModal = false;
    this.addNewSelectionInCart.emit(true);
  }
}
